exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card{color:inherit}.card .ant-card-body{display:flex;align-items:center}.card .custom-image img{display:block;height:80px;width:80px;border-radius:100%}.card .custom-card{padding:10px 16px}.card .custom-card p{color:#555}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/Card/PatientCard.scss
// module id = 584
// module chunks = 0